import React from "react";
import logoIcon from '../../images/logo_icon.png';
import factIcon from '../../images/FormImages/fact_icon.png';
import { getLeftPanelStyles } from '../../styles/AutoRegisterFormStyles';

const LeftPanel = ({ step, isCompact = false, content, timeTrackingMethod, isMobileView = false }) => {
  const styles = getLeftPanelStyles(isCompact, isMobileView);
  
  const getStepContent = () => {
    if (!content) return null;
    
    const stepContent = content[`step${step}`];
    
    if (!stepContent) return null;
    
    // default icon (step 1)
    let iconSrc = logoIcon;
    let iconAlt = "eGodziny";
    
    // change icon based on step
    if (step === 2) {
      iconSrc = factIcon;
      iconAlt = "Fakt";
    }
    
    return (
      <div style={styles.leftPanel}>
        {isMobileView ? (
          <>
            <div style={styles.leftSection}>
              <h2 style={styles.leftTitle}>{stepContent.title}</h2>
              <img 
                src={iconSrc} 
                alt={iconAlt} 
                style={styles.icon}
              />
            </div>
            <p 
              style={styles.leftText}
              dangerouslySetInnerHTML={{ __html: stepContent.text }}
            />
          </>
        ) : (
          <>
            <h2 style={styles.leftTitle}>{stepContent.title}</h2>
            <img 
              src={iconSrc} 
              alt={iconAlt} 
              style={styles.icon}
            />
            <p 
              style={styles.leftText}
              dangerouslySetInnerHTML={{ __html: stepContent.text }}
            />
          </>
        )}
      </div>
    );
  };

  return getStepContent();
};

export default LeftPanel; 